import React from "react";
import Toast from "cogo-toast";
import {apiDeleteToken} from "./Actions";
import {FiCopy} from "react-icons/fi";
import {useSelector} from "react-redux";
import ETable, {DeleteIconBtn, EditIconBtn} from "../components/Table";
import {fmtDateTime} from "../../../functions/formatDate";

const COMPETENCY_LABEL = {full: "Plná práva", external: "Externí přístup", reader: "Čtečka",ticketValidator:"Ticket validator"};

const TokenCell = ({token}) => {
    if (!token) return "-";
    return (
        <div style={{display: "flex", alignItems: "center", gap: "6px"}}>
            <span style={{fontFamily: "monospace", fontSize: "var(--enigoo-fs-sm)"}}>
                {token.length > 20 ? token.substring(0, 20) + "..." : token}
            </span>
            <button
                type="button"
                onClick={() => { navigator.clipboard.writeText(token); Toast.info("Token byl zkopírován do schránky"); }}
                style={{background: "none", border: "none", cursor: "pointer", padding: "2px", color: "#64748b", display: "flex", alignItems: "center"}}
            >
                <FiCopy size={13}/>
            </button>
        </div>
    );
};

const AccessTokenTable = ({data, setData}) => {
    const user = useSelector((state) => state.user);

    const deleteItem = (id) => {
        if (!user?.user?.rights?.enigooTurniketsEdit) return;
        apiDeleteToken(user.activeAreal.id, id, () => {
            setData(prev => prev.filter(v => v.id !== id));
            Toast.success("Token byl odstraněn");
        }, (error) => {
            let msg = "Nepodařilo se odstranit token.\n";
            if (error.data === "TOKEN_NOT_FOUND") msg += "Nebyl nalezen.";
            else msg += "Neznámá chyba";
            Toast.error(msg);
        });
    };

    const columns = [
        {header: "ID",            key: "id"},
        {header: "Název",         key: "name"},
        {header: "Token",         render: row => <TokenCell token={row.token}/>},
        {header: "Datum od",      render: row => fmtDateTime(row.dateFrom)},
        {header: "Datum do",      render: row => fmtDateTime(row.dateTo)},
        {header: "Právo",         render: row => COMPETENCY_LABEL[row.competency] ?? ""},
        {header: "Poslední akce", render: row => row.lastAction ?? "-"},
        {header: "Možnosti", render: row => (
            <div style={{display: "flex", gap: "6px", alignItems: "center"}}>
                <EditIconBtn to={"/access/token/detail/" + row.id}/>
                {user?.user?.rights?.enigooTurniketsEdit && (
                    <DeleteIconBtn onClick={() => deleteItem(row.id)}/>
                )}
            </div>
        )},
    ];

    return <ETable columns={columns} data={data}/>;
};

export default AccessTokenTable;
